import apiFetch from '../apiFetch'
export default function (token, dossierIds, dossierSubTypes) {
  const body = { dossierIdList: dossierIds, dossierSubTypes }
  return apiFetch({ endPoint: 'UnattendedProcess/GetDossierNumbers', method: 'POST', body, token })
}
